<template>
  <el-dialog
    class="venueAppointment-detail"
    title="场馆预约审批详情"
    :visible="detailShow"
    width="700px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <el-descriptions
      class="margin-top"
      title=""
      :column="2"
      border
      direction="horizontal"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-school"></i>
          场馆名称
        </template>
        {{ venueAppointmentDetail.venueName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          申请人 </template
        >{{ venueAppointmentDetail.teacherName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-check"></i>
          是否通过
        </template>
        {{ venueAppointmentDetail.reviewList[0].status == "1" ? "是" : "否" }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="margin-top"
      title=""
      :column="1"
      border
      direction="vertical"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          审批说明
        </template>
        {{ venueAppointmentDetail.reviewList[0].feedback }}
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    detailShow: {
      type: Boolean,
    },
    venueAppointmentDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    dialogOpen() {},
    dialogClose() {
      this.$emit("update:detailShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./venueAppointmentDetail.scss";
</style>